import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from './AuthProvider';
import { Building2, Loader2 } from "lucide-react";

const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const auth = useAdminAuth();
    const nav = useNavigate();

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await auth.login(email, password);
            nav('/admin/dashboard');
        } catch (err: any) {
            setError(err?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-neutral-900 p-4">
            <div className="w-full max-w-md bg-gradient-to-b from-neutral-800 to-neutral-900 border border-neutral-800 p-8 rounded-lg shadow-lg">
                <div className="flex flex-col items-center mb-6">
                    <div className="w-16 h-16  rounded-lg flex items-center justify-center">
                        {/* <svg className="w-10 h-10" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="24" height="24" rx="4" fill="#111827" />
                            <path d="M6 12h12M6 8h12M6 16h12" stroke="#4b98f0ff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg> */}
                        <div className="flex justify-center">
                            <div className="w-16 h-16 bg-blue-500 rounded-lg flex items-center justify-center">
                                <Building2 className="w-10 h-10 text-white-900" />
                            </div>
                        </div>
                    </div>
                    <h2 className="text-white text-2xl font-semibold mt-4">CRM Admin</h2>
                    <p className="text-sm text-neutral-400 mt-1">Sign in to your admin dashboard</p>
                </div>

                {error && <div className="text-red-400 bg-red-900/20 px-3 py-2 rounded mb-4">{error}</div>}

                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="block text-sm text-neutral-300 mb-1">Email</label>
                        <input
                            className="mt-1 block w-full bg-neutral-800 border border-neutral-700 rounded p-2 text-neutral-100 placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-amber-500"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            placeholder="you@company.com"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm text-neutral-300 mb-1">Password</label>
                        <input
                            className="mt-1 block w-full bg-neutral-800 border border-neutral-700 rounded p-2 text-neutral-100 placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-amber-500"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-amber-500 hover:bg-amber-600 text-neutral-900 font-medium p-2 rounded"
                        disabled={loading}
                    >
                        {loading ? 'Signing in...' : 'Sign in'}
                    </button>
                </form>

                <div className="text-center text-sm text-neutral-500 mt-6">© {new Date().getFullYear()} CRM Platform</div>
            </div>
        </div>
    );
};

export default Login;
